import React, { useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../shared/components/Sidebar";
import {
  Button,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import "./articles.css";
import useArticlesViewModel from "../hooks/useArticlesViewModel";
import ArticleCard from "./ArticleCard";

const Articles = () => {
  const navigate = useNavigate();
  const {
    articles,
    loading,
    loadingMore,
    error,
    hasMore,
    fetchMoreArticles,
    deleteArticle,
  } = useArticlesViewModel();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this article?")) {
      try {
        await deleteArticle(id);
      } catch (err) {
        // Error is already set by ViewModel
      }
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-article/${id}`);
  };

  const observer = useRef();
  const lastArticleRef = useCallback(
    (node) => {
      if (loading || loadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchMoreArticles();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, loadingMore, hasMore, fetchMoreArticles]
  );

  if (loading && articles.length === 0) {
    return (
      <div className="dashboard">
        <Sidebar />
        <div className="dashboard--content article-list">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard--content article-list">
        {error && <Snackbar open={true} autoHideDuration={6000} message={error} />}

        <div className="add-article">
          <Button variant="contained" onClick={() => navigate("/add-article")}>
            Add New Article
          </Button>
        </div>

        <div className="article-list__container">
          {articles.length === 0 && !loading ? (
            <p>No articles available.</p>
          ) : (
            articles.map((article, index) => (
              <ArticleCard
                key={article.id}
                article={article}
                onDelete={handleDelete}
                onEdit={handleEdit}
                ref={index === articles.length - 1 ? lastArticleRef : null}
              />
            ))
          )}
        </div>
        {loadingMore && (
          <div className="loader">
            <CircularProgress />
          </div>
        )}
        {!hasMore && !loadingMore && articles.length > 0 && (
          <p style={{ textAlign: "center", marginTop: "20px", color: "#777" }}>No more articles</p>
        )}
      </div>
    </div>
  );
};

export default Articles;
